import { LogCollectorService } from '../service/log-collector';
import { setThemeWeb } from './theming';
import { postMessageToParent } from './utils';

postMessageToParent<AppModel.SignStatusEvent>({
  type: 'sign-status',
  value: 'loading',
});

const bodyElement = document.querySelector('body');
bodyElement.classList.add('sfc-body-color-background-subtle');
if (location.search.includes('theme=dark')) {
  bodyElement.dataset.sfcTheme = 'dark';
} else if (
  document.querySelector('rass-sign[source-name=login]') ||
  document.querySelector('rass-sign[source-name=idin]') ||
  document.querySelector('rass-pre-login') ||
  document.querySelector('rass-intermediate')
) {
  // Set the theme via JS on the login screen since it doesnt contain a summary. Useful for dynamic theming based on OS setting
  // Also set the theme via JS on the idin screens since it can't follow the RABOTHM cookie. We use custom extra CSS there set in the rass-summary cmp
  setThemeWeb();
}

export default function () {
  if (document.querySelector('rass-sign')) {
    const logCollector = new LogCollectorService();
    logCollector.addEventListeners();
  }
}
